// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Attendance .dateCircle {
  border-radius: 50%;
  width: 29px;
  height: 29px;
}
.Attendance .CalendarBox {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 60px;
  box-sizing: border-box;
}
.Attendance .CalendarBoxBorder {
  border: 1px solid #ededed;
  cursor: pointer;
}
.Attendance .gridMaxWidth {
  max-width: 100%;
}
.Attendance .tableHeadMargin {
  margin: 0;
}
.Attendance .public-holiday {
  background: #0044b3;
  color: white;
}
.Attendance .week-off {
  background: #6aa1f5;
  color: white;
}
.Attendance .approved {
  background: #2bbc49;
  color: white;
}
.Attendance .pendding-for-app {
  background: #6b1106;
  color: white;
}
.Attendance .approve-post {
  background: #f6fd56;
  color: white;
}
.Attendance .rejected {
  background: #787878;
  color: white;
}
.Attendance .delete-update {
  background: #ffa856;
  color: white;
}
.Attendance .delete-approval {
  background: #fecb99;
  color: white;
}
.Attendance .error-post {
  background: #ff92d7;
  color: white;
}
.Attendance .error-delete {
  background: #ff9193;
  color: white;
}
.Attendance .lwop {
  background: #ff0017;
  color: white;
}
.Attendance .box-table {
  position: relative;
  overflow: overlay;
  border: 1px solid #efefef;
  border-radius: 4px;
}
.Attendance .tableHead {
  position: sticky;
  top: 0;
  right: 0;
  z-index: 1;
}

.dataInfoTime {
  height: 70px;
  border-radius: 30px;
  width: 225px;
  border: 1px solid #cbd5e1;
  display: flex;
  align-items: center;
  justify-content: center;
}`, "",{"version":3,"sources":["webpack://./src/components/AttendanceEnquiry/attendance.scss"],"names":[],"mappings":"AACE;EACE,kBAAA;EACA,WAAA;EACA,YAAA;AAAJ;AAEE;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,YAAA;EACA,sBAAA;AAAJ;AAEE;EACE,yBAAA;EAEA,eAAA;AADJ;AAGE;EACE,eAAA;AADJ;AAGE;EACE,SAAA;AADJ;AAGE;EACE,mBAAA;EACA,YAAA;AADJ;AAGE;EACE,mBAAA;EACA,YAAA;AADJ;AAGE;EACE,mBAAA;EACA,YAAA;AADJ;AAGE;EACE,mBAAA;EACA,YAAA;AADJ;AAGE;EACE,mBAAA;EACA,YAAA;AADJ;AAGE;EACE,mBAAA;EACA,YAAA;AADJ;AAGE;EACE,mBAAA;EACA,YAAA;AADJ;AAGE;EACE,mBAAA;EACA,YAAA;AADJ;AAGE;EACE,mBAAA;EACA,YAAA;AADJ;AAGE;EACE,mBAAA;EACA,YAAA;AADJ;AAGE;EACE,mBAAA;EACA,YAAA;AADJ;AAIE;EACE,kBAAA;EAEA,iBAAA;EACA,yBAAA;EACA,kBAAA;AAHJ;AAME;EAEE,gBAAA;EACA,MAAA;EACA,QAAA;EACA,UAAA;AALJ;;AAYA;EACA,YAAA;EACA,mBAAA;EACA,YAAA;EACA,yBAAA;EAEA,aAAA;EACA,mBAAA;EACA,uBAAA;AAVA","sourcesContent":[".Attendance {\n  .dateCircle {\n    border-radius: 50%;\n    width: 29px;\n    height: 29px;\n  }\n  .CalendarBox {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    width: 100%;\n    height: 60px;\n    box-sizing: border-box;\n  }\n  .CalendarBoxBorder {\n    border: 1px solid #ededed;\n    // background: #fcfcfc;\n    cursor: pointer;\n  }\n  .gridMaxWidth {\n    max-width: 100%;\n  }\n  .tableHeadMargin {\n    margin: 0;\n  }\n  .public-holiday {\n    background: #0044b3;\n    color: white;\n  }\n  .week-off {\n    background: #6aa1f5;\n    color: white;\n  }\n  .approved {\n    background: #2bbc49;\n    color: white;\n  }\n  .pendding-for-app {\n    background: #6b1106;\n    color: white;\n  }\n  .approve-post {\n    background: #f6fd56;\n    color: white;\n  }\n  .rejected {\n    background: #787878;\n    color: white;\n  }\n  .delete-update {\n    background: #ffa856;\n    color: white;\n  }\n  .delete-approval {\n    background: #fecb99;\n    color: white;\n  }\n  .error-post {\n    background: #ff92d7;\n    color: white;\n  }\n  .error-delete {\n    background: #ff9193;\n    color: white;\n  }\n  .lwop {\n    background: #ff0017;\n    color: white;\n  }\n\n  .box-table {\n    position: relative;\n    // max-height: calc(100vh - 150px);\n    overflow: overlay;\n    border: 1px solid #efefef;\n    border-radius: 4px;\n  }\n\n  .tableHead {\n    // background: #f9fbfc;\n    position: sticky;\n    top: 0;\n    right: 0;\n    z-index: 1;\n    // &:hover {\n    //   background: #f9fbfc;\n    // }\n  }\n}\n\n.dataInfoTime{\nheight: 70px;\nborder-radius: 30px;\nwidth: 225px;\nborder: 1px solid #cbd5e1;\n// background: #f1f5f9;\ndisplay: flex;\nalign-items: center;\njustify-content: center;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
